(function () {
  const visibilityState = new WeakMap();
  const previousFocus = new WeakMap();

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0
    );
  }

  function getSuccessText(message) {
    const title =
      message
        .querySelector('.gfb__content-title')
        ?.textContent.trim() || '';

    const content =
      message
        .querySelector('.content')
        ?.innerText.trim() || '';

    return [title, content]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function restorePreviousFocus(message) {
    const previous = previousFocus.get(message);

    window.setTimeout(function () {
      if (
        previous &&
        document.contains(previous) &&
        typeof previous.focus === 'function'
      ) {
        previous.focus();
      }
    }, 150);
  }

  function enhanceDismissButton(message) {
    const dismiss = message.querySelector('.dismiss');

    if (!dismiss) return;

    /*
      If it is already a real button,
      just make sure it has an accessible name.
    */
    if (dismiss.tagName === 'BUTTON') {
      dismiss.type = 'button';

      dismiss.setAttribute(
        'aria-label',
        'Close confirmation message'
      );

      return;
    }

    /*
      Save Globo's original click behavior.
      Example:
      Globo.FormBuilder.dismiss(this)
    */
    const originalOnclick =
      dismiss.getAttribute('onclick');

    const button = document.createElement('button');

    button.type = 'button';

    /*
      Copy Globo's existing classes and other
      attributes so styling/functionality is preserved.
    */
    Array.from(dismiss.attributes).forEach(
      function (attribute) {
        if (
          attribute.name === 'role' ||
          attribute.name === 'tabindex' ||
          attribute.name === 'onclick'
        ) {
          return;
        }

        button.setAttribute(
          attribute.name,
          attribute.value
        );
      }
    );

    button.className = dismiss.className;

    button.setAttribute(
      'aria-label',
      'Close confirmation message'
    );

    /*
      Preserve the existing X icon.
    */
    button.innerHTML = dismiss.innerHTML;

    /*
      Preserve Globo's own working close action.
      Native buttons automatically support
      mouse, Enter and Space activation.
    */
    if (originalOnclick) {
      button.setAttribute(
        'onclick',
        originalOnclick
      );
    }

    /*
      After the message closes, return focus
      to the control the user was on before
      the success message appeared.
    */
    button.addEventListener(
      'click',
      function () {
        restorePreviousFocus(message);
      }
    );

    dismiss.replaceWith(button);
  }

  function handleSuccessMessages() {
    const messages = document.querySelectorAll(
      '.message.success'
    );

    messages.forEach(function (message) {
      /*
        First make the close control
        keyboard accessible.
      */
      enhanceDismissButton(message);

      const visible = isVisible(message);

      const wasVisible =
        visibilityState.get(message) === true;

      visibilityState.set(
        message,
        visible
      );

      /*
        Only announce/focus when the success
        message changes from hidden to visible.
      */
      if (!visible || wasVisible) return;

      const successText =
        getSuccessText(message);

      if (!successText) return;

      /*
        Save where the user was before we
        move focus to the confirmation.
      */
      previousFocus.set(
        message,
        document.activeElement
      );

      /*
        Make the visible success message
        accessible to assistive technology.
      */
      message.setAttribute(
        'role',
        'status'
      );

      message.setAttribute(
        'aria-live',
        'polite'
      );

      message.setAttribute(
        'aria-atomic',
        'true'
      );

      /*
        VoiceOver previously only announced
        the heading, so provide the complete
        confirmation as its accessible label.
      */
      message.setAttribute(
        'aria-label',
        successText
      );

      /*
        Allow programmatic focus without
        putting the whole message into the
        normal Tab sequence.
      */
      message.setAttribute(
        'tabindex',
        '-1'
      );

      window.setTimeout(function () {
        if (!isVisible(message)) return;

        message.focus({
          preventScroll: false
        });
      }, 300);
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      const observer =
        new MutationObserver(function () {
          handleSuccessMessages();
        });

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'class',
            'style'
          ]
        }
      );

      handleSuccessMessages();
    }
  );
})();